import { service } from ".";

export default {
  getAll: () => service.get("/services"),
  getOne: (id) => service.get(`/services/${id}`),
  getAllPaginate: (query) => service.get(`/services/paginate?${query}`),
  create: (data) => service.post("/services", data),
  update: (id, data) => service.put(`/services/${id}`, data),
  delete: (id) => service.delete(`/services/${id}`),
};
